import { createSlice } from '@reduxjs/toolkit';
import { StorageKey } from 'constants/localStorage';
import { ThemeMode } from 'types/theme';

interface IInitialState {
  theme: ThemeMode;
}

const theme = localStorage.getItem(StorageKey.THEME) as ThemeMode;

const initialState: IInitialState = {
  theme: theme || ThemeMode.LIGHT,
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    changeTheme: (state, action) => {
      state.theme = action.payload;
      localStorage.setItem(StorageKey.THEME, action.payload);
    },
  },
});

export const { changeTheme } = themeSlice.actions;

export default themeSlice.reducer;
